import CardClass from "../../../CardClass";
import Table from "../../../Table";
import { withRouter } from "react-router-dom";
import MainContext from "../../../../Context/MainContext/MainContext";

export default withRouter(
  class CardAdminOrderStatusReasonDetailList extends CardClass {
    static contextType = MainContext; // For legacy class components

    /**
     * Renders the content of the card.
     */
    renderContent() {
      return (
        <Table
          search={true}
          columns={[
            { key: "id", name: "ID", type: "number" },
            { key: "name", name: "Name", type: "string", width: "150" },
            { key: "description", name: "Description", type: "string" },
            {
              key: "orderStatusReasonId",
              name: "Order Status Reason",
              type: "orderStatusReason",
              filter: true,
            },
          ]}
          rows={Object.values(this.context.orderStatusReasonDetailsIndexed)}
          onClick={(orderStatusReasonDetail) => {
            this.props.history.push({
              pathname:
                "/admin/orderStatusReasonDetail/" + orderStatusReasonDetail.id,
            });
          }}
        />
      );
    }
  },
);
